import createLucideIcon from '../createLucideIcon';

const ArrowUpSquare = createLucideIcon('ArrowUpSquare', [
  [
    'rect',
    {
      width: '18',
      height: '18',
      x: '3',
      y: '3',
      rx: '2',
      ry: '2',
      key: '1m3agn',
    },
  ],
  ['polyline', { points: '16 12 12 8 8 12', key: '1gpmhk' }],
  ['line', { x1: '12', x2: '12', y1: '16', y2: '8', key: '1n8uid' }],
]);

export default ArrowUpSquare;
